import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	container: {
		padding: "30px",
	},
	horizontalLine: {
		borderBottom: "1px solid #00000040",
		height: 7,
		marginLeft: "15px",
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	horizontalLine2: {
		borderBottom: "1px solid #00000040",
		height: 7,
		marginLeft: "15px",
	},
	headingContainer: {
		maxWidth: "1024px",
		marginBottom: "30px",
	},
	heading: {
		[theme.breakpoints.down("sm")]: {
			fontSize: "16px",
			textAlign: "center",
		},
	},
	imageCounter: {
		marginBottom: "100px",
		width: "100%",
		maxWidth: "1000px",
		borderRadius: "30px",
		[theme.breakpoints.down("sm")]: {
			marginBottom: "30px",
		},
	},
	bodyOfCounter: {
		maxWidth: "1024px",
		textAlign: "justify",
		// [theme.breakpoints.down("sm")]: {
		// 	textAlign: "justify",
		// },
	},
	attachContainer: {
		maxWidth: "1024px",
		marginBottom: 40,
		padding: "0 20px",
	},
	description: {
		marginBottom: "60px",
		lineHeight: "2.3",
	},
	attachCardContainer: {
		padding: "10px",
		borderRadius: "10px",
		backgroundColor: "#fff",
		marginBottom: "25px",
	},
	activitySectionContainer: {
		maxWidth: "1024px",
		marginBottom: 40,
		padding: "0 20px",
		[theme.breakpoints.down("sm")]: {
			padding: "0px",
			marginBottom: 20,
		},
	},
	attachCardDownloadBtn: {
		background: "linear-gradient(237deg, #fe6280 25%, #c5103b 155%)",
		height: "30px",
		borderRadius: "8px",
		padding: "10px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		width: "110px",
		boxShadow: "1px 6px 20px 0 #ffc2ce",
		transition: "box-shadow 200ms linear",
		"&:hover": {
			boxShadow: "none",
			transition: "box-shadow 200ms linear",
		},
	},
	activityTitle: {
		fontWeight: "bold",
		whiteSpace: "nowrap",
		[theme.breakpoints.down("sm")]: {
			whiteSpace: "nowrap",
			textOverflow: "ellipsis",
			overflow: "hidden",
			fontSize: "17px",
		},
	},
}));
export default useStyles;
